import {
  createEcommercePayload,
  CreateEcommercePayloadItemParams,
} from '@/features/gtm/internal/helper/create-ecommerce-payload';
import { emitGTMEvent } from '@/features/gtm/shared/helper/emit-gtm-event';

export type TrackAddToCartParams = CreateEcommercePayloadItemParams;

export function trackRemoveFromCart(ecommerceParams: TrackAddToCartParams): void {
  const payload = createEcommercePayload(ecommerceParams);
  emitGTMEvent('REMOVE_FROM_CART', payload);
}
